import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "@/redux/user/types";
import { getStateKeyList } from "@/utils/redux/state";
import { UserResponseDto } from "@/api/interface";
import { FetchStatus } from "@/redux/util/type";

const initialState: UserState = {
	userInfoFetchState: "READY",
	userInfo: null,
};

export const USER_STATE_KEY_LIST = getStateKeyList(initialState);

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		reset: () => initialState,
		setUserInfoFetchState: (state, { payload }: PayloadAction<FetchStatus>) => {
			state.userInfoFetchState = payload;
		},
		setUserInfoFetchRequest: (state) => {
			state.userInfoFetchState = "PENDING";
		},
		setUserInfoFetchSuccess: (state, { payload }: PayloadAction<UserResponseDto>) => {
			state.userInfoFetchState = "SUCCESS";
			state.userInfo = payload;
		},
		setUserInfoFetchFailure: (state) => {
			state.userInfoFetchState = "FAILURE";
		},
	},
});

export const userReducer = userSlice.reducer;
